export const docsNavigation = [
  {
    title: 'Getting Started',
    links: [
      { title: 'Introduction', href: '/docs/introduction' },
      { title: 'Platform Support', href: '/docs/introduction#platform-support' },
      {
        title: 'Installation',
        links: [
          { title: 'Unity', href: '/docs/installation' },
          { title: 'Android Native', href: '/docs/android-native' },
          { title: 'iOS Native', href: '/docs/ios-native' },
          { title: 'Godot (Beta)', href: '/docs/godot' },
        ],
      },
      { title: 'Offline-First Guide and Behaviours', href: '/docs/unity/offline-first-guide' },
      { title: 'Usage Requirements', href: '/docs/usage-requirements' },
      { title: 'Pre-Launch Checklist', href: '/docs/integration-checklist' },
      { title: 'SDK Integration Reference', href: '/docs/sdk-integration-reference' },
    ],
  },
  {
    title: 'Authentication',
    links: [
      { title: 'Overview', href: '/docs/unity/authentication/overview' },
      {
        title: 'Unity',
        links: [
          { title: 'Integrate Noctua Account', href: '/docs/unity/authentication/integrate-noctua-account' },
          { title: 'Updating Player Account', href: '/docs/unity/authentication/updating-player-account' },
          { title: 'Integrate Authentication Features', href: '/docs/unity/authentication/integrate-authentication-features' },
          { title: 'Cloud Game State', href: '/docs/unity/authentication/cloud-game-state' },
        ],
      },
    ],
  },
  {
    title: 'In-App Purchase',
    links: [
      { title: 'Overview', href: '/docs/unity/iap/overview' },
      { title: 'Setup SKUs in Stores', href: '/docs/unity/iap/setup-skus-in-stores' },
      {
        title: 'Unity',
        links: [
          { title: 'Displaying In-Game Products', href: '/docs/unity/iap/displaying-in-game-products' },
          { title: 'Item Delivery', href: '/docs/unity/iap/item-delivery' },
          { title: 'Implementing Purchase Flow', href: '/docs/unity/iap/implementing-in-app-purchase' },
          { title: 'Refund Mechanism', href: '/docs/unity/iap/refund-mechanism' },
          { title: 'Pending Purchases & Errors', href: '/docs/unity/iap/pending-purchases-and-errors' },
          { title: 'Noctua Gold', href: '/docs/unity/iap/implementing-noctua-gold' },
          { title: 'Noctua Redeem', href: '/docs/unity/iap/noctua-redeem' },
          { title: 'Restore Purchases', href: '/docs/unity/iap/restore-purchases' },
          { title: 'Non-Consumable Products For Consumable Currency', href: '/docs/unity/iap/non-consumable-product-that-contains-consumable-currency' },
        ],
      },
    ],
  },
  {
    title: 'In-App Ads',
    links: [
      { title: 'Overview', href: '/docs/unity/iaa/overview' },
      {
        title: 'Unity',
        links: [
          {
            title: 'Implementing Ads',
            links: [
              { title: 'Overview', href: '/docs/unity/iaa/implementing-in-app-ads' },
              { title: 'Interstitial', href: '/docs/unity/iaa/ad-formats/interstitial' },
              { title: 'Rewarded', href: '/docs/unity/iaa/ad-formats/rewarded' },
              { title: 'Rewarded Interstitial', href: '/docs/unity/iaa/ad-formats/rewarded-interstitial' },
              { title: 'App Open', href: '/docs/unity/iaa/ad-formats/app-open' },
              { title: 'Banner', href: '/docs/unity/iaa/ad-formats/banner' },
            ],
          },
          { title: 'Installing Ad Network Adapters', href: '/docs/unity/iaa/installing-ad-network-adapters' },
          {
            title: 'Advanced Configuration',
            links: [
              { title: 'Overview', href: '/docs/unity/iaa/advanced-configuration' },
              { title: 'Ad Network Adapters', href: '/docs/unity/iaa/advanced-ad-network-adapters' },
              { title: 'Main-Thread Callbacks', href: '/docs/unity/iaa/advanced-main-thread-callbacks' },
            ],
          },
          { title: 'Fallback Mechanism', href: '/docs/unity/iaa/fallback-mechanism' },
          { title: 'Direct Cross-Promotion', href: '/docs/unity/iaa/cross-promotion' },
          { title: 'IAA Event Tracking', href: '/sdk/iaa-event-tracking' },
        ],
      },
    ],
  },
  {
    title: 'Event Tracking',
    links: [
      { title: 'Overview', href: '/docs/unity/tracking/overview' },
      {
        title: 'Unity',
        links: [
          { title: 'Built-in Analytics', href: '/docs/unity/tracking/built-in-analytics' },
          { title: 'Custom Events', href: '/docs/unity/tracking/custom-events-tracking' },
          { title: 'Revenue Tracking', href: '/docs/unity/tracking/tracking-revenue' },
          { title: 'Feature Engagement Tracking', href: '/docs/unity/tracking/feature-engagement-tracking' },
          { title: 'Game Stage Tracking', href: '/docs/unity/tracking/game-stage-tracking' },
        ],
      },
      {
        title: 'Android Native',
        links: [
          { title: 'Custom Events', href: '/docs/android-native/custom-event-tracking' },
          { title: 'Revenue Tracking', href: '/docs/android-native/tracking-revenue' },
        ],
      },
      {
        title: 'iOS Native',
        links: [
          { title: 'Custom Events', href: '/docs/ios-native/custom-event-tracking' },
          { title: 'Revenue Tracking', href: '/docs/ios-native/tracking-revenue' },
        ],
      },
      {
        title: 'Godot (Beta)',
        links: [
          { title: 'Custom Events', href: '/docs/godot/custom-event-tracking' },
          { title: 'Revenue Tracking', href: '/docs/godot/tracking-revenue' },
          { title: 'Session & Experiments', href: '/docs/godot/session-and-experiments' },
        ],
      },
    ],
  },
  {
    title: 'Platform',
    links: [
      { title: 'Overview', href: '/docs/unity/platform/overview' },
      { title: 'Locale Information', href: '/docs/unity/platform/locale' },
      { title: 'Announcements', href: '/docs/unity/platform/content-announcement' },
      { title: 'Rewards', href: '/docs/unity/platform/content-reward' },
      { title: 'Social Media', href: '/docs/unity/platform/content-social-media' },
      { title: 'Customer Service', href: '/docs/unity/platform/content-customer-service' },
      /*
      {
        title: 'In-game Rewards',
        links: [
          { title: 'Providing Rewards', href: '/docs/unity/platform/providing-in-game-rewards' },
          { title: 'Receiving Rewards', href: '/docs/unity/platform/receiving-in-game-rewards' },
        ],
      },
       * */
    ],
  },
  {
    title: 'LiveOps Campaign',
    links: [
      { title: 'Overview', href: '/docs/unity/liveops-campaign/overview' },
      {
        title: 'Unity',
        links: [
          { title: 'Campaign API', href: '/docs/unity/liveops-campaign/api' },
          { title: 'Campaign JSON Schema', href: '/docs/unity/liveops-campaign/schema' },
          { title: 'Actions & Analytics', href: '/docs/unity/liveops-campaign/actions-and-analytics' },
          { title: 'Progress Tracker', href: '/docs/unity/liveops-campaign/progress-tracker' },
        ],
      },
    ],
  },
  {
    title: 'App Management',
    links: [
      { title: 'In-App Review & Updates', href: '/docs/unity/app-management' },
    ],
  },
  {
    title: 'Debug & Testing',
    links: [
      {
        title: 'Unity',
        links: [
          { title: 'Noctua Inspector (Beta)', href: '/docs/unity/debug-and-testing/noctua-inspector' },
          { title: 'Retrieve SDK Logs', href: '/docs/unity/debug-and-testing/retrieve-sdk-logs' },
          { title: 'IAA Debugging', href: '/docs/unity/debug-and-testing/iaa-debugging' },
          { title: 'Taichi Debugging & Testing', href: '/docs/unity/debug-and-testing/taichi-debugging' },
          { title: 'Event Tracking Debugging', href: '/docs/unity/debug-and-testing/event-tracking-debugging' },
        ],
      },
    ],
  },
  {
    title: 'Advanced',
    links: [
      {
        title: 'Unity',
        links: [
          { title: 'Remote Config', href: '/docs/advanced/firebase-remote-configs' },
          { title: 'Firebase Utilities', href: '/docs/advanced/firebase-utilities' },
          { title: 'Push Notifications', href: '/docs/advanced/push-notifications' },
          { title: 'Adjust Attribution', href: '/docs/advanced/adjust-attribution' },
          { title: 'Pseudo User ID', href: '/docs/advanced/pseudo-user-id' },
        ],
      },
    ],
  },
  {
    title: 'API Reference',
    links: [
      { title: 'Overview', href: '/sdk' },
      {
        title: 'Core',
        links: [
          { title: 'Noctua', href: '/sdk/noctua' },
          { title: 'Noctua.Firebase', href: '/sdk/noctua-firebase' },
        ],
      },
      {
        title: 'Modules',
        links: [
          { title: 'Noctua.Auth', href: '/sdk/auth' },
          { title: 'Noctua.IAP', href: '/sdk/iap' },
          { title: 'Noctua.IAA', href: '/sdk/iaa' },
          { title: 'Noctua.Event', href: '/sdk/event' },
          { title: 'Noctua.App', href: '/sdk/app' },
          { title: 'Noctua.LiveOpsCampaign', href: '/docs/unity/liveops-campaign/api' },
        ],
      },
      {
        title: 'Platform',
        links: [
          { title: 'Noctua.Platform', href: '/sdk/platform' },
          { title: 'Noctua.Platform.Locale', href: '/sdk/platform-locale' },
          { title: 'Noctua.Platform.Content', href: '/sdk/platform-content' },
        ],
      },
      { title: 'Types & Enums', href: '/sdk/types' },
    ],
  },
]
